import * as React from 'react'
import {Util, Time} from 'yougile-util'
import {Lang} from 'yougile-lang'

export const DndButton = (props: {dnd: boolean; onClick(): void}) => {
  const bem = Util.bemFrom('notification-center', 'dnd', 'button')
  return (
    <div className={bem({dnd: props.dnd})} onClick={props.onClick}>
      {Lang.msg.doNotDisturb}
      <div className={bem('icon')} />
    </div>
  )
}

const DndCancel = (props: {
  dndUntil: number
  onChange(value: number): void
}) => {
  const bem = Util.bemFrom('notification-center', 'dnd', 'menu')
  const onChange = () => props.onChange(0)
  return (
    <div className={bem()}>
      <div className={bem('title')}>
        {Lang.msg.notificationsSnoozed} {Time.formatShort(props.dndUntil)}
      </div>
      <div className={bem('options')}>
        <div className={bem('item')} onClick={onChange}>
          {Lang.msg.turnOnNotifications}
        </div>
      </div>
    </div>
  )
}

const hours2Str = (hours: number) => {
  switch (hours) {
    case 0.5:
      return Lang.msg.min30
    default:
      return Lang.findMsg('hour' + hours)
  }
}
const DndMenu = (props: {onChange(value: number): void}) => {
  const bem = Util.bemFrom('notification-center', 'dnd', 'menu')
  const onClick = (hours: number) => () => props.onChange(hours)
  const options = [0.5, 1, 2, 4, 8, 24].map(hours => (
    <div className={bem('item')} key={hours} onClick={onClick(hours)}>
      {hours2Str(hours)}
    </div>
  ))
  return (
    <div className={bem()}>
      <div className={bem('title')}>{Lang.msg.turnOffNotifications}:</div>
      <div className={bem('options')}>{options}</div>
    </div>
  )
}

export const Dnd = (props: {
  dndUntil: number
  onChange(value: number): void
}) => {
  return props.dndUntil > 0 ? (
    <DndCancel onChange={props.onChange} dndUntil={props.dndUntil} />
  ) : (
    <DndMenu onChange={props.onChange} />
  )
}
